import React, { Component } from "react";
import { Button, Badge, Table } from "react-bootstrap";
import { Utils } from "../../../../Common/Utilis";
import _ from "lodash"

export class LedgersSection extends Component<any, any> {
  state = {
    isDataValid: false, // State to track if data is valid
    variance: 0.00, // Example variance value
    ledgers: [
      { id: 1, name: "Guest", openingBalance: 1000, closingBalance: 1200 },
      { id: 2, name: "Deposit", openingBalance: 1500, closingBalance: 1500 },
      { id: 2, name: "Direct Bill", openingBalance: 1500, closingBalance: 1500 },
    ],
  };

  componentDidMount(): void {
    let { ledgers } = this.state;
    ledgers=ledgers.map((x:any)=>{
     x.openingBalance= Utils.currencyFormatWithOutdoller( x.openingBalance)
x.closingBalance=Utils.currencyFormatWithOutdoller( x.closingBalance)
return x;
    });
    this.setState({ledgers})
  }
  // Method to calculate variance
  calculateVariance = () => {
    const { ledgers } = this.state;
    return ledgers.reduce(
      (acc, ledger) => acc + (ledger.closingBalance - ledger.openingBalance),
      0
    );
  };

 handleCurrencyOnFocus = (field,event, index) => {
    let newval = (!event.target.value) ?
      "" : Utils.currencyFormatWithoutDollar(event.target.value);
    const { ledgers } = this.state;
   const  _ledgers = _.cloneDeep(ledgers);
    ledgers[index][field] = newval
    this.setState({ ledgers: _ledgers });
  }
  handleCurrencyOnBlur = (field,event, index) => {
    const { ledgers } = this.state;
    const _ledgers = _.cloneDeep(ledgers);
    if (!isNaN(event.target.value)) {
      let fieldValue = !event.target.value ? "" : Utils.currencyFormatWithoutDollar(_ledgers[index][field]);
      _ledgers[index][field] = fieldValue;
    }
    this.setState({ ledgers: _ledgers });
  }


  handleDynamicFieldChange = ( field,event, index) => {
    let value = event.target.value;
 
        Utils.AllowOnlyPositiveNumnberInput(event)

        if (value?.toString()?.includes("-"))
          return

      

        value = Utils.removeInvaildCharFromAmount(value, 10);

    const { ledgers } = this.state
    let _ledgers = _.cloneDeep(ledgers)
    _ledgers[index][field] = value
  

    this.setState({ ledgers:_ledgers });
  }

  render() {
    const { isDataValid, variance, ledgers } = this.state;
    const isBalanced = variance === 0.00;

    return (
      <div className="ladger-section">
        <ul>
          <li className="d-flex">
            <div className="lable">Variance</div>
            <div className="badge green ml-auto">{Utils.currencyFormat(variance)}</div>
          </li>
          <li className="seperator"></li>
          <li>
            <div className="lable">Ledgers</div>
          </li>
          <li>
            <div className="react-bootstrap-table table-modify">
              <Table className="table remove-border">
                <thead>
                  <tr>
                    <th></th>
                    <th className="align-right">Opening</th>
                    <th className="align-right width-124">Closing</th>
                  </tr>
                </thead>
                <tbody>
                  {ledgers.map((ledger,index) => (
                    <tr key={ledger.id}>
                      <td className="lable">{ledger.name}</td>
                      <td className="align-right">{ ledger.openingBalance}</td>
                      <td className="align-right d-flex justify-content-end">
                        <input
                          className="form-control"
                          type="text"
                          value={ledger.closingBalance}
                       onFocus={(e) =>  this.handleCurrencyOnFocus("closingBalance",e, index) }
                                   onBlur={(e) =>  this.handleCurrencyOnBlur("closingBalance",e,  index) }
                                   onChange={(e) => this.handleDynamicFieldChange("closingBalance",e, index)}
                                
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </li>
        </ul>

        {/* <Button variant="success" disabled={!isDataValid}>
          Complete Entry
        </Button> */}
        {/* <div>
          <Badge variant="danger">Variance: {variance}</Badge>
        </div>
        <div className="react-bootstrap-table">
          <Table className="table remove-border">
            <thead>
              <tr>
                <th></th>
                <th>Opening</th>
                <th>Closing</th>
              </tr>
            </thead>
            <tbody>
              {ledgers.map((ledger) => (
                <tr key={ledger.id}>
                  <td>{ledger.name}</td>
                  <td>{ledger.openingBalance}</td>
                  <td>
                    <input
                    className="form-control"
                      type="number"
                      value={ledger.closingBalance}
                      onChange={(e) => {
                        const newLedgers = ledgers.map((l) =>
                          l.id === ledger.id
                            ? { ...l, closingBalance: Number(e.target.value) }
                            : l
                        );
                        this.setState({ ledgers: newLedgers });
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div> */}
      </div>
    );
  }
}
